import medrixoHero from "../../images/products/medrixo.webp";
import medrixoMockup from "../../images/products/medrixo-mockup.webp";
import taxongoHero from "../../images/products/taxongo.webp";
import taxongoMockup from "../../images/products/taxongo-mockup.webp";

export const productImages = {
  medrixo: {
    hero: medrixoHero,
    mockup: medrixoMockup,
  },
  taxongo: {
    hero: taxongoHero,
    mockup: taxongoMockup,
  },
};
